module.exports = __webpack_public_path__ + "img/clothing105.1fd9a59f.jpg";